export const ORDER_FORM_RESUME = {
  group1: [
    {
      id: '1',
      label: 'Qtd. SKU',
      campo: 'qtdItens',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'qtdItens',
      isFormat: false,
    },
    {
      id: '2',
      label: 'Qtd. Peças',
      campo: 'qtdItem',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'qtdItem',
      isFormat: false,
    },
    {
      id: '3',
      label: 'Volumes',
      campo: 'volume',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'volume',
      isFormat: false,
    },
    {
      id: '4',
      label: 'M3',
      campo: 'cubagem',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'cubagem',
      isFormat: true,
    },
    {
      id: '5',
      label: 'P. Bruto',
      campo: 'pesoBruto',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'pesoBruto',
      isFormat: true,
    },
  ],
  group2: [
    {
      id: '1',
      label: 'Vr. Produtos',
      campo: 'valorProdutos',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'valorProdutos',
      isFormat: true,
    },
    {
      id: '2',
      label: 'Vr. IPI',
      campo: 'valorIpi',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'valorIpi',
      isFormat: true,
    },
    {
      id: '3',
      label: 'Vr. ST',
      campo: 'vIcmsSt',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'vIcmsSt',
      isFormat: true,
    },
    {
      id: '4',
      label: 'Vr. Abatimentos',
      campo: 'valorDesconto',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'valorDesconto',
      isFormat: true,
    },
    {
      id: '5',
      label: 'Vr. Total',
      campo: 'valorTotal',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'valorTotal',
      isFormat: true,
    },
  ],
  group3: [
    {
      id: '1',
      label: 'Vr. Comissão',
      campo: 'vCommission',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'vComissao',
      isFormat: true,
    },
    {
      id: '2',
      label: 'Vr. Ctr 1',
      campo: 'controle1',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'controle1',
      isFormat: true,
    },
    {
      id: '3',
      label: 'Vr. Ctr 2',
      campo: 'controle2',
      enabled: true,
      visible: true,
      fieldInJsonOrder: 'controle2',
      isFormat: true,
    },
  ],
}
